

import { OnboardingStatusResponse } from "../services/authService";

export const ONBOARDING_STEPS = [
  "/choose-account",
  "/select-treatment",
  "/business-information",
  "/individual-information",
  "/individual-provider-verification",
  "/service-area",
  "/billing/business",
  "/billing/confirm",
  "/billing/success",
  "/billing/subscription",
  "/profileStatus",
  "/provider-team",
  "/menu-builder",
];

export const getTargetOnboardingPath = (
  data: OnboardingStatusResponse,
  partner: any,
  currentPath: string = ""
): string => {
  if (!data.accountTypeCompleted) return "/choose-account";
  if (!data.treatmentCompleted) return "/select-treatment";
 if (!data.businessInfoCompleted) {
  const accountType =
    partner?.accountType ||
    localStorage.getItem("accountType");

  return accountType === "INDIVIDUAL"
    ? "/individual-information"
    : "/business-information";
}
  if (!data.serviceAreaAndLocationCompleted) return "/service-area";

  // Billing pending
  if (!data.subscriptionCompleted) {
    if (currentPath.startsWith("/billing")) {
      return currentPath;
    }
    return "/billing/business";
  }

  // Billing completed -> show success flow once
  const billingFlowDone =
    sessionStorage.getItem("billingFlowDone");

  if (!billingFlowDone) {
    if (currentPath === "/billing/success") {
      return "/billing/subscription";
    }

    if (
      currentPath === "/billing/subscription"
    ) {
      sessionStorage.setItem(
        "billingFlowDone",
        "true"
      );
      return "/profileStatus";
    }

    return "/billing/success";
  }

  const dashboardEditableRoutes = [
    "/service-area",
    "/business-information",
    "/menu-builder",
  ];

  if (
    dashboardEditableRoutes.some(path =>
      currentPath.startsWith(path)
    )
  ) {
    return currentPath;
  }

  return "/profileStatus";

};